import { Link as RouterLink } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'
import { useNotify, useRefresh } from 'react-admin'
import { KitStatusLabels } from '../../../utils/constants'
import { isTestComplete, getLabTestResultPdf } from '../../list/ResultList/Fields'
import { showAcknowledgeButton, markAcknowledgment } from '../../list/ResultList/Actions'
import ResultNav from './ResultNav'

// 'notifyComplete' bundles "test complete" + "patient notified" into one
// label — the notification half now lives in the Follow-up card, so the
// header badge only needs to say the test itself is complete.
const STATUS_BADGE_OVERRIDES = { notifyComplete: 'Test Complete' }

const ResultHeaderBar = ({ record, nav }) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const statusLabel = STATUS_BADGE_OVERRIDES[record?.status] ?? KitStatusLabels[record?.status] ?? record?.status
  const hasReport = isTestComplete(record)
  const acknowledged = record?.providerAcknowledgedAt > 0 && record?.providerAcknowledgedBy

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Button component={RouterLink} to="/provider-portal/results" size="small" sx={{ minHeight: 44 }}>
          <span className="fa-solid fa-arrow-left"></span>&nbsp;Results
        </Button>
        <Typography variant="h6" component="span">
          Kit {record?.kitId}
        </Typography>
        {statusLabel && <span className="label bg-default text-white">{statusLabel}</span>}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        {!['pendingConfirmation', 'manualReview'].includes(record?.status) && showAcknowledgeButton(record) && (
          <Button
            variant={acknowledged ? 'outlined' : 'contained'}
            color={acknowledged ? 'inherit' : 'success'}
            size="small"
            onClick={async () => await markAcknowledgment(record, acknowledged, notify, refresh)}
            sx={{ minHeight: 44 }}
          >
            <span className={`fa-solid fa-${acknowledged ? 'x' : 'check'}`}></span>&nbsp;
            {acknowledged ? 'Un-acknowledge' : 'Acknowledge'}
          </Button>
        )}
        {hasReport && (
          <Button
            variant="contained"
            size="small"
            onClick={async () => await getLabTestResultPdf(record, notify)}
            sx={{ minHeight: 44 }}
          >
            <span className="fa-solid fa-download"></span>&nbsp;PDF report
          </Button>
        )}
        <ResultNav {...nav} />
      </Box>
    </Box>
  )
}

export default ResultHeaderBar
